module.exports = __webpack_public_path__ + "static/media/about_img.714bd172.png";